import { array, boolean, object, string } from 'yup';

const columns = object({
  columnName: string().required().ensure(),
  id: string().required(),
});
const schema = object({
  id: string().ensure(),
  name: string()
    .required()
    .ensure()
    .min(1)
    .test(
      'is-unique',
      ({ label, value }) => `${label} The template “${value}” already exists`,
      (value, testContext) => {
        const { options, path, createError } = testContext;
        const { templates } = options.context || {};
        const templateFound = (templates || []).find(
          (t) => t.name.trim() === value.trim()
        );
        if (!templateFound) return true;
        return createError({
          path,
          message: `The template "${value}" already exists`,
        });
      }
    ),
  tenantId: string().ensure(),
  boardId: string().ensure(),
  boardViewId: string().nullable().default(null),
  columns: array().of(columns).required().ensure().default([]),
  deleted: boolean().default(false),
  createdBy: string(),
  ref: object(),
}).required();

export default schema;
